import axios from "@/config/http";
import ip from "../config/ip.js";

let base = ip.Ips.ip1;

/**
 * 查询
 * @param {*} params
 * @returns
 */
export const loadSubscriberPageApi = params => {
  return axios.get(`${base}/biz/subscriber/page`, { params: params });
};
/**
 * 查询
 * @param {*} params
 * @returns
 */
export const loadSubscriberListApi = params => {
  return axios.get(`${base}/biz/subscriber/list`, { params: params });
};

/**
 * 查询详情
 * @param {*} id
 * @returns
 */
export const getSubscriberInfoApi = id =>
  axios.get(`${base}/biz/subscriber/`, { params: { id: id } });

/**
 * 查询小程序
 * @param {*} id
 * @param {*} params
 * @returns
 */
export const querySubscriberMaPageApi = (id, params) =>
  axios.get(`${base}/biz/subscriber/${id}/ma/page`, { params: params });

/**
 * 查询收获地址
 * @param {*} id
 * @param {*} params
 * @returns
 */
export const querySubscriberContactPageApi = (id, params) =>
  axios.get(`${base}/biz/subscriber/${id}/contact/page`, { params: params });

/**
 * 查询用户-优惠券信息
 * @param {*} id
 * @param {*} params
 * @returns
 */
export const querySubscriberCouponPageApi = (id, params) =>
  axios.get(`${base}/biz/subscriber/${id}/coupon/page`, { params: params });

/**
 * 查询用户-工单信息
 * @param {*} id
 * @param {*} params
 * @returns
 */
export const querySubscriberOrderPageApi = (id, params) =>
  axios.get(`${base}/biz/subscriber/${id}/order/page`, { params: params });

/**
 *会员优惠券
 */
export const queryCouponHistoryPageApi = params => {
  return axios.get(`${base}/biz/coupon/history/page`, { params: params });
};
/**
 * 核销优惠券
 * @param {*} params
 * @returns
 */
export const consumeCouponApi = params => {
  return axios.post(`${base}/biz/coupon/history/consume`, params);
};
/**
 * 用户的权益卡
 *
 * @param {*} params
 * @returns
 */
export const queryPrivilegeCardPageApi = params => {
  return axios.get(`${base}/biz/subscriber/privilege/page`, { params: params });
};

/**
 *  导出会员用户
 *
 * @param {*} params
 * @returns
 */
export const exportSubscriberApi = params => {
  return axios.post(`${base}/biz/subscriber/export`, { params: params });
}



// WEBPACK FOOTER //
// ./src/api/subscriber.js